export const academicLevels = [
  {
    id: 1,
    customerName: "High School",
  },
  {
    id: 2,
    customerName: "College",
  },
  {
    id: 3,
    customerName: "University",
  },
  {
    id: 4,
    customerName: "Master's",
  },
  {
    id: 5,
    customerName: "Ph.D.",
  },
];
